(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athens-book-salon-pulse"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pulse-home]').forEach((root) => {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-scroll-prev]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('[data-scroll-rail="' + button.dataset.scrollPrev + '"]')?.scrollBy({left:-360,behavior:'smooth'});
      });
    });
    root.querySelectorAll('[data-scroll-next]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('[data-scroll-rail="' + button.dataset.scrollNext + '"]')?.scrollBy({left:360,behavior:'smooth'});
      });
    });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold:.1});
      root.querySelectorAll('.pulse-reveal').forEach((el) => observer.observe(el));
    } else {
      root.querySelectorAll('.pulse-reveal').forEach((el) => el.classList.add('is-visible'));
    }
    const hero = root.querySelector('.pulse-hero');
    const stack = root.querySelector('.pulse-hero__stack');
    if (!reduced && hero && stack && matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('pointermove',(e)=>{
        const r=hero.getBoundingClientRect();
        stack.style.setProperty('--mx',(((e.clientX-r.left)/r.width)-.5)*18+'px');
        stack.style.setProperty('--my',(((e.clientY-r.top)/r.height)-.5)*18+'px');
      });
      hero.addEventListener('pointerleave',()=>{stack.style.setProperty('--mx','0px');stack.style.setProperty('--my','0px');});
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
